export default __webpack_public_path__ + "static/media/history-undo.a9254d82.svg";